export async function clearPageCache(reloadAfterClear = true): Promise<void> {
  if ('caches' in window) {
    const promises = (await caches.keys()).map(async (name: string): Promise<void> => {
      await caches.delete(name);
    });

    await Promise.all(promises);

    if (reloadAfterClear) {
      window.location.reload();
    }
  }
}
